import styled, { keyframes } from 'styled-components';
import { v2Colors, v2FontFamily } from '../../formInputsV2/styles/tokens';

const popIn = keyframes`
  from { opacity: 0; transform: translateY(10px) scale(0.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

export const Wrap = styled.div`
  width: 100%;
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-family: ${v2FontFamily};
`;

// Filled with the brand green so the card reads against a white page —
// white copy + a white countdown ring on top.
export const Card = styled.div`
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 38px 40px;
  background-color: ${v2Colors.primary};
  border-radius: 20px;
  box-shadow: 0 18px 44px rgba(0, 166, 81, 0.3), 0 4px 12px rgba(0, 166, 81, 0.2);
  animation: ${popIn} 220ms ease-out;

  @media (max-width: 560px) {
    max-width: 340px;
    gap: 20px;
    padding: 30px 22px;
  }
`;

export const Message = styled.h5`
  margin: 0;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.45;
  color: #ffffff;
  white-space: nowrap;

  @media (max-width: 560px) {
    white-space: normal;
    font-size: 15px;
  }
`;

export const RingWrap = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 108px;
  height: 108px;

  svg {
    display: block;
    width: 100%;
    height: 100%;
    transform: rotate(-90deg);
  }

  .track {
    stroke: rgba(255, 255, 255, 0.28);
  }

  .progress {
    stroke: #ffffff;
    stroke-linecap: round;
    transition: stroke-dashoffset 1s linear;
  }

  .value {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    font-weight: 700;
    color: #ffffff;
    font-variant-numeric: tabular-nums;
  }

  @media (max-width: 560px) {
    width: 92px;
    height: 92px;

    .value {
      font-size: 24px;
    }
  }
`;
